<template>
  <div class="device-list-page">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-container">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备信息查看</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="设备类型">
          <el-select v-model="searchForm.productId" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="消防吊桶" value="2"></el-option>
            <el-option label="清洗喷枪" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="SN/ID查询">
          <el-input v-model="searchForm.keyword" placeholder="输入 SN 或 udid 关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="fetchDeviceList(1)">查询</el-button>
          <el-button icon="el-icon-refresh-right" @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card" header="🔍 绑定设备列表">
      <el-table :data="deviceList" v-loading="loading" border stripe style="width: 100%">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column prop="productId" label="设备类型" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.productId === '2' ? 'danger' : 'success'">
              {{ scope.row.productId === '2' ? '消防吊桶' : '清洗喷枪' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sn1" label="主SN" min-width="150"></el-table-column>
        <el-table-column prop="associatedSnList" label="关联SN列表" min-width="300">
          <template slot-scope="scope">
            <div v-for="(sn, index) in scope.row.associatedSnList" :key="index">
              <small class="sn-text">{{ sn }}</small><br>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="bind_date" label="绑定时间" width="180"></el-table-column>

        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small" icon="el-icon-edit"  v-if="scope.row.productId==='1'" >
              修改
            </el-button>
            <el-button @click="handleUnbind(scope.row)" type="text" size="small" style="color: #F56C6C;" icon="el-icon-delete">
              解绑
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-area">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="fetchDeviceList"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from '../../utils/request'
// import router from '../../router'
export default {
  name: 'DeviceListTable',
  // 核心修复区域：确保 data() 函数完整且返回所有必要的属性
  data () {
    return {
      loading: false,
      // 必须在这里初始化 searchForm 对象
      searchForm: {
        productId: '',
        keyword: ''
      },
      // 必须在这里初始化 pagination 对象
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 必须初始化 deviceList 数组
      deviceList: []
    }
  },
  mounted () {
    this.methodToTrigger()
  },
  methods: {
    // ... (其他方法保持不变) ...
    fetchDeviceList (page = 1) {
      this.pagination.currentPage = page
      // this.$message.info(`调用设备列表 API (页码: ${page}, 搜索: ${this.searchForm.keyword})...`)
      this.methodToTrigger()
    },
    methodToTrigger: function () {
      axios.get(`/data/bind/query?sn=${this.searchForm.keyword}&pageNum=${this.pagination.currentPage}&pageSize=${this.pagination.pageSize}&productId=${this.searchForm.productId}`).then(res => {
        this.deviceList = res.data.list
        this.pagination.total = res.data.total
        this.deviceList.forEach(device => {
          var associatedSnList = []
          if (device.productId === '1') {
            associatedSnList.push('遥控器：' + device.sn1)
            associatedSnList.push('飞机：' + device.sn2)
            associatedSnList.push('水枪：' + device.sn3)
            device.associatedSnList = associatedSnList
          } else {
            let associatedSnList = []
            associatedSnList.push('天空端：' + device.sn1)
            associatedSnList.push('udid：' + device.udid)
            device.associatedSnList = associatedSnList
          }
        })
      }).catch(error => {
        console.log('error', error)
      })
    },

    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.fetchDeviceList(1)
    },

    resetSearch () {
      // 确保这里的对象属性存在
      this.searchForm = {
        productId: '',
        keyword: ''
      }
      this.fetchDeviceList(1)
    },

    handleEdit (row) {
      if (row.productId === '1') {
        this.$router.push({
          name: 'DeviceBinding',
          query: {
            deviceId: row.id,
            isEditMode: true,
            productId: row.productId,
            sn1: row.sn1,
            sn2: row.sn2,
            sn3: row.sn3
          }
        })
      } else {
        this.$router.push({
          name: 'DeviceBinding',
          query: {deviceId: row.id, isEditMode: true, productId: row.productId, sn11: row.sn1, udid: row.udid}
        })
      }
    },

    // 2. 处理解绑操作
    handleUnbind (row) {
      this.$confirm(`确定要解绑设备 ${row.id} 吗?`, '警告', {
        confirmButtonText: '确定解绑',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // this.$message.info(`TODO: 调用解绑 API, 正在解绑设备 ID: ${row.id}`)
        axios.get(`/data/bind/del?id=${row.id}&&productId=${row.productId}`).then(res => {
          this.methodToTrigger()
        }).catch(() => {
          this.$message.info('已取消解绑操作')
        })
      })
    }
  }
}
</script>

<style scoped>
  .breadcrumb-container {
    margin-bottom: 20px;
  }
  .search-card {
    margin-bottom: 20px;
  }
  .pagination-area {
    margin-top: 20px;
    text-align: right;
  }
  .sn-text {
    color: #606266;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/DeviceListTable.vue